import { Component, OnDestroy, OnInit } from '@angular/core';
import { Brand } from 'app/brand-config';
import { AuthService } from 'app/modules/authentication/services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  isLoggingIn = false;
  callbackSubscription: Subscription;
  
  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.callbackSubscription = this.authService.handleRedirectCallback();
  }

  ngOnDestroy(): void {
    this.callbackSubscription?.unsubscribe();
  }

  async login(brand: Brand) {
    if (this.isLoggingIn) {
      alert('You are already logged in.');
      return;
    }
    this.isLoggingIn = true;

    try {
      await this.authService.setAuthType(brand);

      const scopes = this.authService.getScopes();
      await this.authService.initialize();

      this.authService.clearMSALInteractionState();
      const result = this.authService
        .loginRedirect({ scopes: scopes })
        .then(() => console.log('Redirect initiated'))
        .catch((err) => console.error('Redirect failed', err));
      console.log('Redirect initiated');
    } catch (error) {
      console.error('Login failed', error);
    } finally {
      this.isLoggingIn = false;
    }
  }
  logout() {
    this.authService.fullLogout();
  }
}
